<template>
  <div
    class="auth-page min-h-screen relative w-full bg-center-top bg-no-repeat bg-cover text-center pb-4 sm:pb-20"
  >
    <div class="py-5">
      <img alt="startup ACT" class="startup-auth-logo" src="../../assets/img/header-auth-space.svg" />
    </div>

    <div class="wrap-login w-68 sm:w-75 max-w-full bg-white shadow-lg rounded-sm p-5 mx-auto">
      <h2
        class="text-2xl font-bold leading-normal text-red uppercase border-b-2 border-red-lighter p-5 mb-4"
      >{{ $t("auth.login") }}</h2>
      <div
        v-if="notice"
        class="border border-green-light text-green text-sm px-4 py-3 mb-4 rounded"
      >
        <div class="relative block sm:inline text-left p-0">{{ $t(notice) }}</div>
      </div>
      <div
        v-if="errors != null"
        class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
        {{ errors.message }}
        <div
          v-if="
            renvoiValidationMail.UnverifiedEmail &&
              renvoiValidationMail.sendMax > 0
          "
        >
          <div class="text-center resend-box">
            <span
              class="resend mb-5 inline-block text-sm no-underline border-red-dark  border-b text-red-dark text-sm cursor-pointer"
              v-on:click="resendVerificationEmail()"
            >{{ $t("auth.resend_verification_email") }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="verify"
        class="border border-green-light text-green text-sm px-4 py-3 mb-4 rounded"
      >
        <div class="relative block sm:inline text-left p-0">{{ $t(verify) }}</div>
      </div>

      <form autocomplete="off" v-on:submit.prevent="onSubmit(email, password)" v-if="!requestOtp && !requestPhoneNumber">
        <div class="form-group">
          <sp-input
            theme="default"
            name="email"
            placeholder="Email"
            type="text"
            :icon="require('../../assets/img/envelope.svg')"
            v-model="email"
          ></sp-input>
        </div>

        <div class="form-group">
          <sp-input
            theme="default"
            name="password"
            placeholder="Password"
            :type="typePassword"
            :icon="require('../../assets/img/login-key.svg')"
            v-model="password"
          ></sp-input>
        </div>

        <div class="flex items-center justify-between">
          <sp-checkbox theme="default" name="option" id="remember_me">{{ $t("auth.remember_me") }}</sp-checkbox>
          <a
            v-if="!showpass"
            href="#"
            class="text-sm no-underline cursor-pointer inline-block mb-5 font-bold text-sm hover:text-blue-dark router-link-exact-active router-link-active text-blue"
            @click="showPassword"
          >{{ $t("auth.show_password") }}</a>
          <a
            v-if="showpass"
            href="#"
            class="text-sm no-underline cursor-pointer inline-block mb-5 font-bold text-sm hover:text-blue-dark router-link-exact-active router-link-active text-blue"
            @click="showPassword"
          >{{ $t("auth.hide_password") }}</a>
        </div>

        <div class="text-center">
          <sp-button
            theme="primary"
            space="normal"
            class="w-full uppercase"
            :class="disabled_class"
            type="submit"
          >{{ $t("auth.login") }}</sp-button>
        </div>

        <div class="text-center">
          <sp-link
            theme="primary"
            class="mb-5 inline-block text-blue text-sm no-underline hover:text-blue-darker"
            :to="{ name: 'ForgotPassword' }"
          >{{ $t("auth.forget_password") }}</sp-link>
        </div>
      </form>
      <form autocomplete="off" v-on:submit.prevent="onSubmitPhoneNumber(email, phonenumber)" v-if="requestPhoneNumber">
        <div class="form-group">
          <sp-input
            theme="default"
            name="email"
            disabled="disabled"
            placeholder="Email"
            type="text"
            :icon="require('../../assets/img/envelope.svg')"
            v-model="email"
          ></sp-input>
        </div>

        <div class="form-group">
          <sp-input
            theme="default"
            name="phonenumber"
            placeholder="phone number"
            type="text"
            :icon="require('../../assets/img/login-key.svg')"
            v-model="phonenumber"
          ></sp-input>
        </div>

        <div class="text-center">
          <sp-button
            theme="primary"
            space="normal"
            class="w-full uppercase"
            :class="disabled_class"
            type="submit"
          >{{ $t("auth.login") }}</sp-button>
        </div>

        <div class="text-center">
          <sp-link
            theme="primary"
            class="mb-5 inline-block text-blue text-sm no-underline hover:text-blue-darker"
            :to="{ name: 'ForgotPassword' }"
          >{{ $t("auth.forget_password") }}</sp-link>
        </div>
      </form>
      <form autocomplete="off" v-on:submit.prevent="onSubmitOtp(email, otp)" v-if="requestOtp">
        <div class="form-group">
          <sp-input
            theme="default"
            name="email"
            disabled="disabled"

            placeholder="Email"
            type="text"
            :icon="require('../../assets/img/envelope.svg')"
            v-model="email"
          ></sp-input>
        </div>
        <div  class="border border-green-light text-green text-sm px-4 py-3 mb-4 rounded">
          <div class="relative block sm:inline text-left p-0">
            Veuillez Saisir le code reçu par Email
          </div>
        </div>
        <span class="success" ></span>
        <div class="form-group">
          <sp-input
            theme="default"
            name="otp"
            placeholder="Veuillez Saisir le code reçu par Email"
            type="text"
            :icon="require('../../assets/img/login-key.svg')"
            v-model="otp"
          ></sp-input>
        </div>

    

        <div class="text-center">
          <sp-button
            theme="primary"
            space="normal"
            class="w-full uppercase"
            :class="disabled_class"
            type="submit"
          >{{ $t("auth.login") }}</sp-button>
        </div>

        
      </form>
      <div class="flex items-center justify-center border-t border-grey-lighter pt-5 pb-2" v-if="requestOtp">
        <p class="text-blue">Code non reçu ?</p>
        <button
          id="resendcodebutton"
          @click="resendCode"
          class="inline-block ml-2 font-bold hover:text-red-light text-warning"
        >
          Renvoyer 
        </button>
        <br>
      </div>
      <p v-if="resendrequestcode && resendCountdown > 0">
        Vous pouvez renvoyer le code dans {{ Math.floor(resendCountdown / 60).toString().padStart(2, '0') }}:{{ (resendCountdown % 60).toString().padStart(2, '0') }}
      </p>
      <span v-if="resendrequestcode > 0" class="text-green text-sm px-4 py-3 ">Code Renvoyé attendez 2 minutes pour la prochaine renvoie</span>
      <div class="flex items-center justify-center border-t border-grey-lighter pt-5 pb-2" v-if="!requestPhoneNumber && !requestOtp">
        <p class="text-blue">{{ $t("auth.not_have_account") }}</p>
        <sp-link
          theme="warning"
          class="inline-block ml-2 font-bold hover:text-red-light"
          :to="{
            name: 'register',
            params: { codeInvit: this.$route.params.codeInvit }
          }"
        >{{ $t("auth.sing_up") }}</sp-link>
      </div>
      
    </div>

    <footer
      class="flex items-center justify-between text-grey-darker bg-grey-lighter absolute md:absolute pin-b pin-l invisible md:visible w-full py-1 px-3 transition-all"
    >
      <div class="flex items-center">
        <img
          class="mh-8 mx-2"
          alt="Ministère des Technologies de la Communication et de la Transformation Digitale"
          src="../../assets/img/drapeau.png"
        />
        <span class="text-xxs opacity-60">{{ $t("auth.ministry") }}</span>
      </div>
      <div class="sm:w-70 w-60 text-right text-xs">
        {{ $t("auth.technology_by") }}
        <a
          class="inline-block text-sm font-bold no-underline cursor-pointer transition-all text-grey-darker hover:text-grey-darker"
          href="https://www.satoripop.com/"
          target="_blank"
        >satoripop</a>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  LOGIN,
  LOGINOTP,
  LOGINPHONENUMBER,
  CLEAR_ERROR,
  GET_EMAIL_CODE_INVIT,
  RESEND_VERIFICATION_EMAIL,
  RESEND_OTP_CODE,
  FETCH_INVESTOR_FORM
} from "@/store/actions.type";
import { VERIFY_USER } from "@/store/mutations.type";

import Link from "@/components/spKit/Link.vue";
import Button from "@/components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";
import Checkbox from "@/components/spKit/Checkbox.vue";
import store from "@/store";

export default {
  name: "Login",
  async beforeRouteLeave(to, from, next) {
    await store.commit(VERIFY_USER, false);
    next();
  },
  components: {
    "sp-link": Link,
    "sp-button": Button,
    "sp-input": Input,
    "sp-checkbox": Checkbox
  },
  data() {
    return {
      email: null,
      password: null,
      typePassword: "password",
      showpass: false,
      disabled_class: "",
      code_invit: null,
      notice: null,
      renvoiValidationMail: {
        sendMax: 3,
        userMail: null,
        UnverifiedEmail: false
      },
      applications: [],
      requestOtp : false,
      otp : "",
      requestPhoneNumber :false,
      phonenumber:'',
      resendrequestcode:0,
      resendCountdown: 0, // in seconds
      countdownTimer: null,


    };
  },
  mounted() {
    this.$Progress.start();
    var url = window.location.href;
    var lastSlash = url.lastIndexOf("/");
    var codeInvit = url.substring(lastSlash + 1);
    this.$store.dispatch(GET_EMAIL_CODE_INVIT, codeInvit).then(data => {
      if (data.data[0]) {
        this.email = data.data[0].email;
      }
      this.$Progress.finish();
    });
  },
  methods: {
    onSubmit(email, password) {
      this.renvoiValidationMail.userMail = email;
      this.$store.dispatch(CLEAR_ERROR);
      this.disabled_class = "opacity-50 cursor-not-allowed";
      this.$Progress.start();
      const skipOtp = this.isDeviceTrusted(email);
      this.$store
        .dispatch(LOGIN, {
          email,
          password,
          code_invit: this.$route.params.codeInvit,
          otpskip: skipOtp ? 'TRUSTED_DEVICE' : null 
        })
        .then(data => {
          this.$Progress.finish();
          this.disabled_class = "";
          if (data.data.token && skipOtp) {
            this.$router.push({ name: "home" });
            return;
          }
          if (
            data.data.user.is_lead == false &&
            data.data.user.member_app == true
          ) {
            //if( data.data.user.lead_app != data.data.user.id  && data.data.user.hash_id  ){
            //Redirect to team edit
            this.requestOtp = true;
            /*this.$router.push({
              name: "team-edit",
              params: {
                app_id: data.data.user.hash_id,
                team_id: data.data.user.id
              }
            });*/
          } else {
            if(data.data.user.role == "Investor") {
              this.requestOtp = true;

               /* if(data.data.user.application && data.data.user.application.hash_id) {
                  this.$router.push({
                    name: 'sessionlessDeclaration',
                    params: {
                      app_id: data.data.user.application.hash_id,
                      appType: data.data.user.application.type.toLowerCase()
                    }
                  });
                } else {
                  this.$router.push({ name: "InvestorFormPrincipal" });
                }*/
            }else {
              //alert('dfsdfsdfsdfsdfssssss');
              this.requestOtp = true;
              /*if(this.requestOtp == false){
                //             

                if(data.data.user.two_factor_confirmed_at == null && data.data.user.confirmed_phone_at==null ){
                  this.$router.push({ name: "home" });
                }
                else{
                  this.requestOtp = true;
                }
                /*if(data.data.user.phone_number!=''){

                  this.requestPhoneNumber = false;
                  this.$router.push({ name: "home" });

                }else{
                  this.requestPhoneNumber = false;
                  //this.$router.push({ name: "home" });
                }
              }else{

                //this.$router.push({ name: "home" });
              }*/
            }
          }
        })
    },
    onSubmitPhoneNumber(email, phonenumber) {
      this.renvoiValidationMail.userMail = email;
      this.$store.dispatch(CLEAR_ERROR);
      this.disabled_class = "opacity-50 cursor-not-allowed";
      this.$Progress.start();
      this.$store
        .dispatch(LOGINPHONENUMBER, {
          email,
          phonenumber,
          code_invit: this.$route.params.codeInvit
        })
        .then(data => {
          this.$Progress.finish();
          this.disabled_class = "";
          if (
            data.data.user.is_lead == false &&
            data.data.user.member_app == true
          ) {
            //if( data.data.user.lead_app != data.data.user.id  && data.data.user.hash_id  ){
            //Redirect to team edit
            this.requestOtp = true;
            /*this.$router.push({
              name: "team-edit",
              params: {
                app_id: data.data.user.hash_id,
                team_id: data.data.user.id
              }
            });*/
          } else {
            if(data.data.user.role == "Investor") {
                if(data.data.user.application && data.data.user.application.hash_id) {
                  this.$router.push({
                    name: 'sessionlessDeclaration',
                    params: {
                      app_id: data.data.user.application.hash_id,
                      appType: data.data.user.application.type.toLowerCase()
                    }
                  });
                } else {
                  this.$router.push({ name: "InvestorFormPrincipal" });
                }
            }else {
              //alert('dfsdfsdfsdfsdfssssss');
              if(this.requestOtp == false){
                alert('sdfsdfsdf');
                this.requestPhoneNumber = false;
                this.requestOtp = true;

              }else{

                this.$router.push({ name: "home" });
              }
            }
          }
        })
    },
    onSubmitOtp(email, otp) {
     // alert('sfdsdfssdf');
      this.renvoiValidationMail.userMail = email;
      this.$store.dispatch(CLEAR_ERROR);
      this.disabled_class = "opacity-50 cursor-not-allowed";
      this.$Progress.start();
      this.$store
        .dispatch(LOGINOTP, {
          email,
          otp,
          code_invit: this.$route.params.codeInvit
        })
        .then(data => {
         
          this.$Progress.finish();
          this.disabled_class = "";
             this.markDeviceTrusted(email);
          if (
            data.data.user.is_lead == false &&
            data.data.user.member_app == true
          ) {
            //if( data.data.user.lead_app != data.data.user.id  && data.data.user.hash_id  ){
            //Redirect to team edit
            this.$router.push({
              name: "team-edit",
              params: {
                app_id: data.data.user.hash_id,
                team_id: data.data.user.id
              }
            });
          } else {
            if(data.data.user.role == "Investor") {
                if(data.data.user.application && data.data.user.application.hash_id) {
                  this.$router.push({
                    name: 'sessionlessDeclaration',
                    params: {
                      app_id: data.data.user.application.hash_id,
                      appType: data.data.user.application.type.toLowerCase()
                    }
                  });
                } else {
                  this.$router.push({ name: "InvestorFormPrincipal" });
                }
            }else {
              this.$router.push({ name: "home" });      
            }
          }
        })
    },

    markDeviceTrusted(email) {
      localStorage.setItem(`trusted_device_${email}`, Date.now().toString());
    },

    isDeviceTrusted(email) {
      const ts = localStorage.getItem(`trusted_device_${email}`);
      if (!ts) return false;
      const now = Date.now();
      const elapsed = now - parseInt(ts);
      return elapsed < 24 * 60 * 60 * 1000; // 24h
    },
    resendCode() {
      //if (this.renvoiValidationMail.sendMax > 0) {
        this.$store
          .dispatch(RESEND_OTP_CODE, {
            email: this.email
          })
          .then(data => {
            this.resendrequestcode = 1;
            this.startCountdown(120); 
          });
      //}
    },
    startCountdown(seconds) {
      this.resendCountdown = seconds;

      if (this.countdownTimer) clearInterval(this.countdownTimer);

      this.countdownTimer = setInterval(() => {
        if (this.resendCountdown > 0) {
          this.resendCountdown--;
        } else {
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },
    showPassword() {
      this.showpass = !this.showpass;
      this.typePassword =
        this.typePassword === "password" ? "text" : "password";
    },
    resendVerificationEmail() {
      if (this.renvoiValidationMail.sendMax > 0) {
        this.$store
          .dispatch(RESEND_VERIFICATION_EMAIL, {
            email: this.renvoiValidationMail.userMail
          })
          .then(data => {
            this.renvoiValidationMail.sendMax -= 1;
            this.notice = "auth.register_success";
          });
      }
    }
  },
  watch: {
    errors() {
      if (this.errors.code === "122") {
        this.renvoiValidationMail.UnverifiedEmail = true;
      }
      this.$Progress.fail();
      this.disabled_class = "";
    }
  },
  computed: {

    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(["verify","ecosystemApp"])
  },
    beforeDestroy() {
          clearInterval(this.countdownTimer);


  }
};
</script>
<style>
.resend-box {
  max-height: 19px;
  margin-top: 8px;
}
</style>
